import { InsightCallback } from "../../dom-tools/Insight";
import { TextFXLetter } from "./TextFXLetter";
import { TextFXModule, TextFXModuleSettings } from "./TextFXModule";

export class TextFXElement
{
  element:Element;
  letters:TextFXLetter[] = [];
  events:Map<string,TextFXModuleSettings[]> = new Map<string,TextFXModuleSettings[]>();
  initialEvent:string;

  dispatch( eventName:string )
  {
    if ( ! this.events.has( eventName ) )
    {
      return;
    } 

    let moduleSettings = this.events.get( eventName );
    moduleSettings.forEach( ms => ms.module.apply( this.letters, ms ) );
  }
}